<div class="grid-toolbar">
    <div class="fill"></div>
    <button
        type="button"
        class="btn btn-tertiary"
        [popover]="columnPicker"
        [outsideClick]="true"
        [adaptivePosition]="true"
        placement="left"
        container="body"
        (onShown)="pickerTooltip.hide()"
        #pickerTooltip="bs-tooltip"
        tooltip="Show/hide columns"
    >
        <span class="fal fa-ellipsis-h"></span>
    </button>
</div>

<ng-template #columnPicker>
    <div class="column-picker">
        <label *ngFor="let col of selectableColumns" class="checkbox">
            <input
                type="checkbox"
                [checked]="isColumnVisible(col.key)"
                (change)="toggleColumn(col.key)"
            />
            {{ col.name }}
        </label>
    </div>
</ng-template>

<div class="flight-log-datatable" #scrollRegion>
    <ag-grid-angular
        [theme]="theme"
        [rowData]="rows"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [context]="this"
        [rowSelection]="rowSelection"
        [selectionColumnDef]="selectionColumnDef"
        [getRowId]="getRowId"
        [rowClassRules]="rowClassRules"
        [headerHeight]="headerHeight"
        [floatingFiltersHeight]="floatingFiltersHeight"
        [rowHeight]="rowHeight"
        [sortingOrder]="sortingOrder"
        [suppressDragLeaveHidesColumns]="true"
        [suppressCellFocus]="true"
        overlayNoRowsTemplate="<span>No flight logs found</span>"
        (gridReady)="onGridReady($event)"
        (sortChanged)="onSortChanged($event)"
        (dragStopped)="onDragStopped($event)"
        (selectionChanged)="onSelectionChanged($event)"
    ></ag-grid-angular>
</div>

<div class="table-footer">
    <ng-container *ngIf="tableConfig.bulkActions?.length > 0">
        <button
            *ngFor="let action of tableConfig.bulkActions"
            type="button"
            class="btn btn-sm btn-default"
            [disabled]="selected.length === 0"
            (click)="action.action(selectedRows)"
        >
            {{ action.name
            }}<ng-container *ngIf="selected.length > 0">
                ({{ selected.length }})</ng-container
            >
        </button>
    </ng-container>
    <div class="fill"></div>
    <pagination
        [totalItems]="tableConfig.totalItems ?? 0"
        [itemsPerPage]="tableConfig.limit"
        [maxSize]="5"
        [boundaryLinks]="true"
        [ngModel]="(tableConfig.currentPage ?? 0) + 1"
        (pageChanged)="onFooterPageChanged($event.page)"
    ></pagination>
</div>
